<div>
  <div class="uk-flex uk-flex-center uk-flex-around">
    <button class="uk-button uk-button-default uk-border-rounded mtb15" [ngClass]="addClassActive(0)"
      (click)="selectTab(0)">สิทธิ์คงเหลือ</button>
    <button class="uk-button uk-button-default uk-border-rounded mtb15" [ngClass]="addClassActive(1)"
      (click)="selectTab(1)">นัดหมายไว้แล้ว</button>
    <button class="uk-button uk-button-default uk-border-rounded mtb15" [ngClass]="addClassActive(2)"
      (click)="selectTab(2)">สิทธิ์ที่ใช้งานแล้ว</button>
  </div>

  <div *ngIf="selectedIndex() === 0">
    <div class="uk-tile uk-tile-primary uk-padding-small uk-text-right" style="background-color: #1369B0;">
      <p class="uk-h4">จำนวนสิทธิ์คงเหลือ {{countDazRemaining()}} ครั้ง</p>
    </div>
    <div class="uk-padding-small">
      <span class="uk-h5 uk-text-bold textBlack">รายละเอียดวันหมดอายุการใช้งานสิทธิ์</span>
    </div>
    <div class="uk-child-width-1-1 uk-text-left" uk-grid="margin:0">
      <div *ngFor="let model of modelsDazRemaining">
        <div class="uk-flex">
          <div class="uk-width-1">
            <div class="uk-margin-small-left uk-margin-small-right">
              <span class="uk-text-bold resizeText">
                หมดอายุ {{model.date}}</span>
            </div>
          </div>
          <div class="uk-width-1 uk-text-right">
            <div class="uk-margin-small-left uk-margin-small-right">
              <span class="uk-text-bold resizeText">
                {{model.count}} ครั้ง</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="selectedIndex() === 1">
    <div class="uk-tile uk-tile-primary uk-padding-small uk-text-right" style="background-color: #1369B0;">
      <p class="uk-h4">จำนวนสิทธิ์ที่นัดหมายไว้แล้ว {{countDazAppointment()}} ครั้ง</p>
    </div>
    <div class="uk-child-width-1-1 uk-text-left" uk-grid="margin:0">
      <div *ngFor="let model of modelsDazAppointment()">
        <div class="uk-border-rounded uk-margin-small-left uk-margin-small-right ">
          <div class="uk-card uk-card-default uk-card-body uk-border-rounded cardBorder mt15">
            <div>วัน - เวลานัดหมาย</div>
            <div class="uk-flex">
              <div class="uk-width-1">
                <div class="uk-margin-small-top">
                  <div class="uk-margin-small-top"><span uk-icon="calendar"></span> {{model.date}} </div>
                </div>
              </div>
              <div class="uk-width-1 uk-text-center">
                <div>
                  <span class="uk-label uk-border-rounded spanBtn" (click)="clickAppointment(model.url)">
                    คลิกพบหมอตามนัด</span>
                  <p class="labelBtn">*กรุณากดเมื่อถึงนัดหมายเท่านั้น*</p>
                </div>
              </div>
            </div>
            <div><span uk-icon="clock"></span> {{model.time}}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div *ngIf="selectedIndex() === 2">
    <div class="uk-tile uk-tile-primary uk-padding-small uk-text-right" style="background-color: #1369B0;">
      <p class="uk-h4">จำนวนสิทธิ์ที่ใช้งานแล้ว {{countDazComplete()}} ครั้ง</p>
    </div>
    <div class="uk-child-width-1-1 uk-text-left" uk-grid="margin:0">
      <div *ngFor="let model of modelsDazComplete()">
        <div class="uk-border-rounded uk-margin-small-left uk-margin-small-right">
          <div class="uk-card uk-card-default uk-card-body uk-border-rounded cardBorder mt15">
            <div>วัน - เวลานัดหมาย</div>
            <div class="uk-flex">
              <div class="uk-width-1">
                <div class="uk-margin-small-top">
                  <div class="uk-margin-small-top"><span uk-icon="calendar"></span> {{model.date}} </div>
                </div>
              </div>
              <div class="uk-width-1 uk-text-center">
                <div>
                  <span class="uk-label uk-border-rounded spanBtn " (click)="clickCompleteInfo(model.url)">
                    รายละเอียดเพิ่มเติม</span>
                </div>
              </div>
            </div>
            <div class="mt15"><span uk-icon="clock"></span> {{model.time}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>